import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Typography, CircularProgress, Container } from '@mui/material';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

const PaymentCancel = () => {
  const history = useHistory();

  useEffect(() => {
    // Redirect to home page after 3 seconds
    const timer = setTimeout(() => {
      history.push('/');
    }, 5000);

    return () => clearTimeout(timer);
  }, [history]);

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '80vh',
          textAlign: 'center',
        }}
      >
        <CancelOutlinedIcon sx={{ fontSize: 80, color: '#f44336', mb: 2 }} />
        <Typography variant="h4" component="h1" gutterBottom>
          Payment Cancelled
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Your payment was cancelled. You will be redirected to the home page shortly.
        </Typography>
        <CircularProgress size={24} sx={{ mt: 2 }} />
      </Box>
    </Container>
  );
};

export default PaymentCancel; 